// Chakra imports
import { Box, useColorModeValue } from "@chakra-ui/react";
import { RoutesType } from "@/src/routes";
// Layout components
import { useState } from "react";
import { Route, Switch } from "react-router-dom";
import routes from "@/src/routes";
import { SidebarContext } from "@/src/contexts/SidebarContext";
import Sidebar from "@/src/components/sidebar/Sidebar";
import Footer from "@/src/components/footer/FooterAdmin";
import { Toaster } from "@/src/components/ui/toaster";
import ProtectedRoute from "@/src/components/ProtectedRoute";

// Custom Chakra theme
export default function Dashboard(props: { [x: string]: any }) {
  const { ...rest } = props;

  // states and functions
  const [toggleSidebar, setToggleSidebar] = useState(false);
  // functions for changing the states from components
  const getRoute = () => {
    return window.location.pathname !== "/admin/full-screen-maps";
  };

  const token = localStorage.getItem("jwtToken");

  // Name of the route matching the current URL, used for document.title.
  // Falls back to a static label so an unmatched path can't render "SM - false".
  const getActiveRouteName = (routes: RoutesType[]): string => {
    const active = routes.find(
      (route) => window.location.href.indexOf(route.path) !== -1,
    );
    return active ? active.name : "Support";
  };

  const layout = token ? "/" : "/auth";

  const getRoutes = (routes: RoutesType[]): any => {
    return routes.map((route: RoutesType, key: any) => {
      if (route.layout === layout) {
        if (route.path === "/account-managers" || route.path === "/coin-logs") {
          return (
            <ProtectedRoute
              path={route.path}
              component={route.component}
              key={key}
            />
          );
        }
        return (
          <Route path={route.path} component={route.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };
  document.documentElement.dir = "ltr";
  document.title = "SM - " + getActiveRouteName(routes);
  const authBg = useColorModeValue("white", "navy.900");

  if (!token) {
    return (
      <Box>
        <SidebarContext.Provider
          value={{
            toggleSidebar,
            setToggleSidebar,
          }}
        >
          <Box
            bg={authBg}
            float="right"
            minHeight="100vh"
            height="100%"
            position="relative"
            w="100%"
            transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
            transitionDuration=".2s, .2s, .35s"
            transitionProperty="top, bottom, width"
            transitionTimingFunction="linear, linear, ease"
          >
            <Toaster />
            {getRoute() ? (
              <Box mx="auto" minH="100vh">
                <Switch>{getRoutes(routes)}</Switch>
              </Box>
            ) : null}
          </Box>
        </SidebarContext.Provider>
      </Box>
    );
  }

  return (
    <Box>
      <SidebarContext.Provider
        value={{
          toggleSidebar,
          setToggleSidebar,
        }}
      >
        <Toaster />
        <Sidebar routes={routes} display="none" {...rest} />
        <Box
          float="right"
          minHeight="100vh"
          height="100%"
          overflow="auto"
          position="relative"
          maxHeight="100%"
          w={{ base: "100%", xl: "calc( 100% - 290px )" }}
          maxWidth={{ base: "100%", xl: "calc( 100% - 290px )" }}
          transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
          transitionDuration=".2s, .2s, .35s"
          transitionProperty="top, bottom, width"
          transitionTimingFunction="linear, linear, ease"
        >
          {getRoute() ? (
            <Box
              mx="auto"
              p={{ base: "20px", md: "30px" }}
              pe="20px"
              minH="100vh"
              pt="50px"
            >
              <Switch>{getRoutes(routes)}</Switch>
            </Box>
          ) : null}
          <Box>
            <Footer />
          </Box>
        </Box>
      </SidebarContext.Provider>
    </Box>
  );
}
